export default __webpack_public_path__ + "static/media/io-g73a035f5f_1920.7d4f46b8.jpg";